import { render, staticRenderFns } from "./DashBoardReportes.vue?vue&type=template&id=14223571"
import script from "./DashBoardReportes.vue?vue&type=script&lang=js"
export * from "./DashBoardReportes.vue?vue&type=script&lang=js"
import style0 from "./DashBoardReportes.vue?vue&type=style&index=0&id=14223571&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports